import { useState, useEffect } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';

/**
 * Fetches a user's public `userProfile` by uid.
 * Returns { profile, loading, error }.
 */
export const useUserProfile = (uid) => {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(!!uid);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!uid) {
      setProfile(null);
      setLoading(false);
      return;
    }

    let cancelled = false;
    setLoading(true);

    getDoc(doc(db, 'users', uid))
      .then((userDoc) => {
        if (cancelled) return;
        setProfile(userDoc.exists() ? userDoc.data()?.userProfile ?? null : null);
      })
      .catch((err) => {
        console.error('Error fetching user profile:', err);
        if (!cancelled) setError(err);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [uid]);

  return { profile, loading, error };
};
